import { ProducerConditionLevel, ProducerConditionType } from '@ftr/contracts/regional-api'
import { assertUnreachable, IconDetails } from '@ftr/foundation'

/**
 * Threshold to determine whether we will add producer warning/error condition
 */
export const PLENTY_OF_RECORDING_REMAINING_HOURS = 100
export const RECORDING_REMAINING_HOURS_WARNING = 70
export const RECORDING_REMAINING_HOURS_ERROR = 10

export function getConditionTitle(condition: ProducerConditionType): string {
  switch (condition) {
    case ProducerConditionType.VersionEndOfLife:
      return 'Recorder version has reached end of life.'
    case ProducerConditionType.VersionExpiring:
      return 'Recorder version is approaching end of life.'
    case ProducerConditionType.LocalRecordingUnsupported:
      return 'Local recording unsupported'
    case ProducerConditionType.RecorderConfigError:
      return 'Recorder infrastructure issue'
    case ProducerConditionType.NotMonitored:
      return 'Not monitored'
    case ProducerConditionType.UnableToRecordPerSchedule:
      return 'Unable to record per schedule'
    case ProducerConditionType.AudioDeviceUnavailable:
      return 'Audio device unavailable'
    case ProducerConditionType.VideoDeviceUnavailable:
      return 'Video device unavailable'
    case ProducerConditionType.ClockNotInSync:
      return 'Clock out of sync'
    case ProducerConditionType.CrashLoop:
      return 'Unstable device/recorder'
    case ProducerConditionType.MismatchedTimezone:
      return 'Mismatched timezone detected'
    case ProducerConditionType.NotHeartbeating:
      return 'No recent heartbeats'
    case ProducerConditionType.StreamingServerError:
      return 'Streaming infrastructure'
    case ProducerConditionType.Upgrading:
      return 'Upgrading Recorder'
    case ProducerConditionType.LowDiskSpace:
      return 'Low disk space'
    case ProducerConditionType.NoDiskSpace:
      return 'Recording error'
    case ProducerConditionType.AudioDeviceError:
      return 'Audio device error'
    case ProducerConditionType.SttStreamingError:
      return 'Speech-to-text streaming issue'
    default:
      return assertUnreachable(condition)
  }
}

export function getSeverityIcon(level: ProducerConditionLevel): IconDetails | undefined {
  switch (level) {
    case ProducerConditionLevel.Fatal:
    case ProducerConditionLevel.Error:
      return {
        name: 'ErrorCircleSolid',
        color: 'Brand',
        gapRight: 'ThreeQuarter',
      }
    case ProducerConditionLevel.Warning:
      return {
        name: 'Warning',
        color: 'Lemon',
        gapRight: 'ThreeQuarter',
      }
    case ProducerConditionLevel.Info:
    case ProducerConditionLevel.Debug:
      return {
        name: 'InfoCircleSolid',
        color: 'Primary',
        gapRight: 'ThreeQuarter',
      }
    default:
      return assertUnreachable(level)
  }
}
